import { Component } from '@angular/core';
import { MatLegacyDialogRef } from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-info-dialog',
  template: `
    <h3 mat-dialog-title>Indirizzi PEC</h3>
    <mat-dialog-content>
      <p>L'indirizzo PEC del destinatario puoi recuperarlo in anagrafe (se cliente)<br>oppure collegandoti al portale INI-PEC (<a style="text-decoration: underline; cursor:pointer; color: var(--primary)" (click)="goToExternalSite()">www.inipec.gov.it</a>)</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-raised-button color="primary" (click)="dialogRef.close()">OK</button>
    </mat-dialog-actions>
  `
})
export class InfoDialogComponent {
  constructor(public dialogRef: MatLegacyDialogRef<InfoDialogComponent>) {}

  goToExternalSite() {
  window.open('https://www.inipec.gov.it', '_blank');
}

}